import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { UserOrganizationRoleEnum } from "../../../../../__generated__/globals.v5";
// IMPORTANT: This function should not be exported, it should only be used by getUserRoles
var getPanelsUrls = function getPanelsUrls(organizationSlug) {
  return {
    admin: "/org/".concat(organizationSlug, "/panel/"),
    adminPanel: "/org/".concat(organizationSlug, "/admin/"),
    onlyLearningAdminPanel: "/org/".concat(organizationSlug, "/panel/estadisticas/generales/"),
    mentor: '/mentor/panel/proyectos',
    professor: '/panel-profesor/',
    leader: "/org/".concat(organizationSlug, "/panel/lider/"),
    collaborator: "/org/".concat(organizationSlug, "/learn/")
  };
};
export var getUserRoles = function getUserRoles(_ref) {
  var _user$organization, _user$organization2;
  var slug = _ref.slug,
    user = _ref.user,
    talentUser = _ref.talentUser,
    t = _ref.t,
    customCollaboratorUrl = _ref.customCollaboratorUrl;
  var userRoleOptions = [];
  var PANELS_URLS = getPanelsUrls(slug);
  if (user !== null && user !== void 0 && user.isB2BAdmin || (user === null || user === void 0 ? void 0 : (_user$organization = user.organization) === null || _user$organization === void 0 ? void 0 : _user$organization.myRole) === 'admin' || (user === null || user === void 0 ? void 0 : (_user$organization2 = user.organization) === null || _user$organization2 === void 0 ? void 0 : _user$organization2.myRole) === 'owner-corporation' || talentUser !== null && talentUser !== void 0 && talentUser.roles.includes(UserOrganizationRoleEnum.ADMIN) || talentUser !== null && talentUser !== void 0 && talentUser.roles.includes(UserOrganizationRoleEnum.SUBADMIN)) {
    userRoleOptions.push({
      value: 'admin',
      url: PANELS_URLS[talentUser !== null && talentUser !== void 0 && talentUser.roles.includes(UserOrganizationRoleEnum.ADMIN) ? 'admin' : 'onlyLearningAdminPanel'],
      label: t('PROFILE_ADMIN')
    });
  }
  if (user !== null && user !== void 0 && user.isMentor // Check this additional mentorPanel B after release
  // && user?.features?.mentorPanel === 'B'
  ) {
    userRoleOptions.push({
      value: 'mentor',
      url: PANELS_URLS['mentor'],
      label: t('PROFILE_MENTOR')
    });
  }
  if (user !== null && user !== void 0 && user.isTeacher) {
    userRoleOptions.push({
      value: 'professor',
      url: PANELS_URLS['professor'],
      label: t('PROFILE_PROFESSOR')
    });
  }
  // for now we don't support the leader role
  // if (isLeader) {
  //   userRoleOptions.push({
  //     value: 'leader',
  //     url: PANELS_URLS['leader'],
  //     label: t('PROFILE_LEADER'),
  //   });
  // }

  // Always add the collaborator option, because a user is always a collaborator too
  userRoleOptions.push({
    value: 'collaborator',
    url: customCollaboratorUrl || PANELS_URLS['collaborator'],
    label: t('PROFILE_MEMBER')
  });
  return userRoleOptions;
};

// Calculate the default option based on the current URL
export var getDefaultSelectedRole = function getDefaultSelectedRole(_ref2) {
  var userRoles = _ref2.userRoles,
    currentUrl = _ref2.currentUrl;
  var isLeaderUrl = currentUrl.indexOf('/panel/lider') > -1;
  var isMentorUrl = currentUrl.indexOf('/mentor/panel') > -1;
  var isProfessorUrl = currentUrl.indexOf('/panel-profesor') > -1;
  var isCollaboratorUrl = currentUrl.indexOf('/learn') > -1 || currentUrl.indexOf('/home') > -1 || currentUrl.indexOf('/hris') > -1;
  var isAdminUrl = currentUrl.indexOf('/panel') > -1 || currentUrl.indexOf('/admin') > -1;

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (isMentorUrl) return userRoles.find(function (el) {
    return el.value === 'mentor';
  });
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (isLeaderUrl) return userRoles.find(function (el) {
    return el.value === 'leader';
  });
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (isProfessorUrl) return userRoles.find(function (el) {
    return el.value === 'professor';
  });
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (isCollaboratorUrl) return userRoles.find(function (el) {
    return el.value === 'collaborator';
  });
  // This one should be evaluated at the end because the above ones include the word "panel" in the url
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (isAdminUrl) return userRoles.find(function (el) {
    return el.value === 'admin';
  });

  // Collaborator is the default role at the end
  return userRoles.find(function (el) {
    return el.value === 'collaborator';
  });
};
export function getUserRoleLabel(currentUserRole) {
  var _rolesMap;
  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!currentUserRole) return undefined;
  var rolesMap = {
    admin: 'PROFILE_ADMIN',
    mentor: 'PROFILE_MENTOR',
    professor: 'PROFILE_PROFESSOR',
    leader: 'PROFILE_LEADER',
    supervisor: 'PROFILE_SUPERVISOR',
    collaborator: 'PROFILE_MEMBER'
  };
  return (_rolesMap = rolesMap[currentUserRole]) !== null && _rolesMap !== void 0 ? _rolesMap : rolesMap['collaborator'];
}
export var mapOptionsFromOrganizations = function mapOptionsFromOrganizations(_ref3) {
  var organizations = _ref3.organizations,
    corporationSlug = _ref3.corporationSlug,
    corporationName = _ref3.corporationName;
  var corporation = {
    name: "".concat(corporationName, " (Corp)"),
    slug: corporationSlug
  };
  return [
  // We are adding the Corp organization as the first option. The organizations array only contains the child organizations
  corporation].concat(_toConsumableArray(organizations)).map(function (org) {
    return _objectSpread(_objectSpread({}, org), {}, {
      isCorp: org.slug === corporationSlug
    });
  }).map(function (organization) {
    var orgUrl = "/org/".concat(organization.slug, "/panel/estadisticas/generales/");
    var corpUrl = "/org/".concat(organization.slug, "/panel/corp/administrar/organizaciones/");
    return {
      label: organization.name || '',
      value: organization.slug || '',
      url: organization.isCorp ? corpUrl : orgUrl
    };
  });
};